import { toast } from "react-toastify";
import { BasicPage } from "../../../theme/Component/BasicPage"
import { ListMenu } from "../../../theme/Component/ListMenu";
import { useEffect, useState } from "react";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { _QualityGarment, _QualityInspection, _single } from "../../../../core/services/dataBean/EntityCatalog";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import useModal, { MODAL_LG, MODAL_md, MODAL_SM, MODAL_XL } from "../../../theme/Component/hooks/useModal";
import { QualityGarmentProperties } from "./QualityGarmentProperties/QualityGarmentProperties";
import { QualityGarmentStandars } from "./QualityGarmentStandars/QualityGarmentStandars";
import { QualityGarmentPiece } from "./QualityGarmentPiece/QualityGarmentPiece";

interface formProps {
    State: number
}

export const QualityGarment = () => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_QualityGarment);

    const [formData, setFormData] = useState<Partial<formProps>>({
        State: 1
    })

    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const modalChange = useModal("", MODAL_SM);
    const modalParts = useModal("Partes Medibles", MODAL_LG);
    const modalStandars = useModal("Estandares de la Prenda", MODAL_LG);
    const modalPiece = useModal("Piezas de la Prenda", MODAL_LG);

    useEffect(() => {
        getLista();
    }, [])

    const getLista = () => {
        instance.getQualityGarmentCatalogPorPropiedades(formData, null).then((resp: any) => {
            setLista(resp);
        }).catch(err => {
            toast.error(err);
        });
    };

    const create = () => {
        setBean({
            State: 1,
            IDEmployee: _single.getAccountID(),

        });
        setModal({ ...modal, "name": `Agregar Inspección de Insumo`, "view": true });
    }

    const changeStateItem = (newState: number) => {
        let x = { ...bean, State: newState }
        editaItem(x);
    };

    const editaItem = (obj: any) => {
        instance.updateQualityGarment(obj).then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
                modalChange.close();
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const head = [
        { title: 'ID', property: 'IDQualityGarment', visible: true },
        { title: 'Código', property: 'CodeGarment', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
    ];


    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const [confirmAction, setConfirmAction] = useState<() => void>(() => () => { });

    const openConfirm = (text: string, fn: () => void) => {
        setConfirmAction(() => fn);
        modalChange.open(text)
    };

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { openConfirm("Confirmar Aprobación", () => changeStateItem(2)) } },
            { titulo: 'Partes Medibles', icono: 'ri-list-check', visible: true, evento: () => { modalParts.open() } },
            // { titulo: 'Estandares de la Pieza', icono: 'mdi mdi-clipboard-text-search-outline', visible: true, evento: () => { modalStandars.open() } },
            { titulo: 'Piezas de la Prenda', icono: 'mdi mdi-tshirt-v', visible: true, evento: () => { modalPiece.open() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const [missingFields, setMissingFields] = useState<string[]>([]);

    const validateData = () => {
        if (validateForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            editaItem(bean);
        }
    }

    const validateForm = () => {
        const requiredFields = [
            "Name"
        ];
        let missing = [];
        for (let field of requiredFields) {
            if (bean[field] === null || bean[field] === undefined || bean[field] === "") {
                missing.push(field);
            }
        }
        setMissingFields(missing);
        return missing.length;
    };

    return (
        <BasicPage titulo="Prendas Base">
            <div className="row">
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} />

                    <Modal modal={modal} updateModal={setModal} eventModal={() => { validateData() }}>
                        <div className="row">
                            <div className="col-md-6">
                                <label className={`${missingFields.includes('Name') ? 'has-error' : ''}`} >Nombre de la Prenda</label>
                                <input type="text" value={bean.Name} onChange={(e) => { setBean({ ...bean, Name: e.target.value }) }} className="form-control" />
                            </div>
                            <div className="col-md-6">
                                <label className={`${missingFields.includes('Quantity') ? 'has-error' : ''}`} >Codigo de la Prenda</label>
                                <input type="text" value={bean.CodeGarment} onChange={(e) => { setBean({ ...bean, CodeGarment: e.target.value }) }} className="form-control" />
                            </div>
                            <div className="col-md-12">
                                <label className={`${missingFields.includes('Quantity') ? 'has-error' : ''}`} >Descripción</label>
                                <textarea value={bean.Description} onChange={(e) => { setBean({ ...bean, Description: e.target.value }) }} className="form-control"></textarea>
                            </div>
                        </div>
                    </Modal>

                    <ModalConfirm modal={modalChange.modal} updateModal={modalChange.setModal} eventModal={() => { confirmAction() }}>
                        <strong>¿Desea Continuar con la accion?</strong>
                    </ModalConfirm>

                    <Modal modal={modalParts.modal} updateModal={modalParts.setModal}>
                        <QualityGarmentProperties QualityGarment={bean} />
                    </Modal>

                    <Modal modal={modalPiece.modal} updateModal={modalPiece.setModal}>
                        <QualityGarmentPiece QualityGarment={bean} />
                    </Modal>

                    <Modal modal={modalStandars.modal} updateModal={modalStandars.setModal}>
                        <QualityGarmentStandars QualityGarment={bean} />
                    </Modal>




                </div>
            </div>
        </BasicPage>
    )
}